













































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Mixins } from 'vue-mixin-decorator';

import Assets from '@/constants/assets';
import Icon, { IconEnum } from '@/modules/shared/components/icon.component.vue';
import Tooltip from '@/modules/shared/components/tooltip.component.vue';
import SearchMixin from '@/modules/shared/mixins/search.mixin.ts';


export interface SelectOption {
  id: number;
  text: string;
}

@Component({
  components: {
    Icon,
    Tooltip,
  },
})
export default class Select extends Mixins<SearchMixin> ( SearchMixin ) {
  @Prop() private selectLabel!: string;
  @Prop() private placeholder!: string;
  @Prop({ default: false }) private readOnly!: boolean;
  @Prop({ default: '' }) private selectError!: string;
  @Prop({ default: '' }) private selectInfo!: string;
  @Prop() private selectOptions!: SelectOption[];
  @Prop({ default: null }) private optionSelected!: SelectOption;
  @Prop({ default: 0 }) private tabIndex!: number;


  private content = '';
  private isFocused: boolean = false;
  private iconEnum = IconEnum;
  private infoHover: boolean = false;
  private selectOpened: boolean = false;
  private blured = false;


  @Watch('optionSelected')
  private watchOptionSelected(newVal: any, oldVal: any) {
    if (newVal === null) {
      this.content = '';
    }
  }

  private created() {
    this.initSearchMixin();
    this.setOptionSelected();
  }

  get infoIcon() {
    let icon = this.iconEnum.InfoStroke;
    if (this.infoHover) {
      icon = this.iconEnum.InfoFill;
    }
    return icon;
  }

  get hasFocus() {
    return this.isFocused && !this.readOnly;
  }

  get hasOptionSelected() {
      return this.optionSelected !== null && this.optionSelected.id;
  }

  get hasError() {
    return this.selectError.length > 0;
  }

  get hasInfo() {
    return this.selectInfo.length > 0 || this.hasSlotContent('tooltip-title');
  }

  get isDirty() {
    return this.hasOptionSelected && !this.readOnly && !this.selectOpened;
  }

  get stateIcon() {
    let icon = '';
    if (this.hasOptionSelected && !this.hasError) {
      icon = this.iconEnum.Tick;
    } else if (this.hasError) {
      icon = this.iconEnum.Cross;
    }
    return icon;
  }

  get arrowIcon() {
    let icon = this.iconEnum.ArrowDown;
    if ( this.selectOpened ) {
      icon = this.iconEnum.ArrowUp;
    }
    return icon;
  }

  private hasSlotContent( slotName: string ) {
    return !!this.$slots[ slotName ];
  }

  private handleFocus() {
    this.isFocused = true;
    this.$emit('on-focus');
  }

  private handleBlur() {
    this.blured = true;
    setTimeout(() => {
      this.blured = false;
    }, 200);
    this.isFocused = false;
    this.closeSelect();
    this.$emit('blur');
  }

  private handleClick() {
    this.openSelect();
    this.$emit('click');
  }

  private handleKeyUp() {
    this.openSelect();
    this.searchString = this.content;
    this.delaySearch();
  }

  private hideError() {
    this.$emit('hide-error');
  }

  private arrowClick() {
    const selectInput = (this.$refs.selectInput as HTMLElement);
    if ( !this.selectOpened && !this.blured && selectInput ) {
      selectInput.focus();
      this.handleFocus();
      this.openSelect();
    }
  }

  private toggleSelectOptions() {
    this.setSelectOpened(!this.selectOpened);
  }

  private setSelectOpened(value: boolean) {
    this.hideError();
    this.selectOpened = value;
  }

  private closeSelect() {
    this.setSelectOpened(false);
  }

  private openSelect() {
    this.setSelectOpened(true);
  }

  private setInfoHover(val: boolean) {
    this.infoHover = val;
  }

  private emitSearchString(searchString: string) {
    this.$emit('search-string', searchString);
  }

  public searchCallback() {
    this.emitSearchString(this.searchString);
  }

  private isOptionSelected(option: SelectOption) {
    return (this.optionSelected !== null && option.id === this.optionSelected.id);
  }

  private initSearchMixin() {
    this.remainingTime = 300;
  }

  private setOptionSelected() {
    this.content = '';
    if ( this.optionSelected !== null ) {
      this.content  = this.optionSelected.text;
    }
  }

  private optionClicked(option: SelectOption) {
    if ( this.isOptionSelected(option) ) {
      this.content = '';
      this.$emit( 'input', null );
    } else {
      this.content = option.text;
      this.$emit( 'option-selected', option);
      this.$emit( 'input', option );
    }
    this.closeSelect();
  }

}
